export default {
    img: {
        folder: {
            create: {
                title: "Ordner anlegen",
                name : "Name des Ordners",
                store: "Anlegen",
                action: "Ordner anlegen",
                empty: "Zu dieser Anlage gibt es noch keine Bilder.",
                noimages: "In diesem Ordner sind noch keine Bilder."
            },
            image: {
                category: {
                    lgs: "LiftGuardian",
                    book: "Prüfbuch",
                    image: "Bilder aus Begehung"
                }
            }
        },

        sort: {
            label   : "Sortieren nach:",
            CAPTURED: "Aufnahmedatum",
            ADDED   : "Hochgeladen am",
            NAME    : "Dateiname",
        },

        upload: {
            action: "Bilder hochladen",
            drop  : "Dateien hier ablegen, um sie hochzuladen",
            running       : "Lade hoch: {done} / {total}",
            finished      : "{done} Dateien hochgeladen",
            waiting       : "{n} wartend",
            processing    : "{n} werden verarbeitet",
            skipped: "Übersprungen, bereits vorhanden",
            summary: {
                done   : "{n} hochgeladen",
                skipped: "{n} übersprungen",
                failed : "{n} fehlgeschlagen",
            },
            retry : "Erneut versuchen",
            retryAll: "Alle erneut versuchen",
            reason: {
                TOO_LARGE  : "Datei zu groß (max. 10 MB)",
                UNSUPPORTED: "Dateityp nicht unterstützt",
                INVALID     : "Die Datei wurde vom Server abgelehnt (ungültige Anfrage)",
                UNAUTHORIZED: "Sitzung abgelaufen, bitte neu anmelden",
                FORBIDDEN   : "Keine Berechtigung zum Hochladen",
                NOT_FOUND   : "Ziel nicht gefunden (Aufnahme oder Ordner existiert nicht mehr)",
                SERVER      : "Serverfehler ({status}), bitte später erneut versuchen",
                NETWORK     : "Keine Verbindung zum Server",
            },
            state: {
                FAILED: "Fehler"
            }
        },

        download: {
            action: "Herunterladen",
            done  : "Die ZIP Datei wurde im Download Verzeichis abgelegt",
            failed: "Der Download ist fehlgeschlagen"
        }
    },
}